import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';

//utils
import queries from '../../utils/queries'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

import HomeConf1 from './homeconf1';
import HomeConf2 from './homeconf2';

import ConfEmpresa1 from './conf/confempresa1';
import ConfEmpresa2 from './conf/confempresa2';
import AddEmpresa1 from './conf/addempresa1';
import AddEmpresa2 from './conf/addempresa2';
import VerEmpresa1 from './conf/verempresa1';
import VerEmpresa2 from './conf/verempresa2';

import ConfHallazgo1 from './conf/confhallazgo1';
import ConfHallazgo2 from './conf/confhallazgo2';
import AddHallazgo1 from './conf/addhallazgo1';
import AddHallazgo2 from './conf/addhallazgo2';
import VerHallazgo1 from './conf/verhallazgo1';
import VerHallazgo2 from './conf/verhallazgo2';

import ConfUtilidad1 from './conf/confutilidad1';
import ConfUtilidad2 from './conf/confutilidad2';
import AddUtilidad1 from './conf/addutilidad1';
import AddUtilidad2 from './conf/addutilidad2';
import VerUtilidad1 from './conf/verutilidad1';
import VerUtilidad2 from './conf/verutilidad2';

import ConfPrograma1 from './conf/confprograma1';
import ConfPrograma2 from './conf/confprograma2';
import AddPrograma1 from './conf/addprograma1';
import AddPrograma2 from './conf/addprograma2';
import VerPrograma1 from './conf/verprograma1';
import VerPrograma2 from './conf/verprograma2';

import ConfContacto1 from './conf/confcontacto1';
import ConfContacto2 from './conf/confcontacto2';
import AddContacto1 from './conf/addcontacto1';
import AddContacto2 from './conf/addcontacto2';
import VerContacto1 from './conf/vercontacto1';
import VerContacto2 from './conf/vercontacto2';

// import ConfOperario1 from './conf/confoperario1';
// import ConfOperario2 from './conf/confoperario2';
// import AddOperario1 from './conf/addoperario1';
// import AddOperario2 from './conf/addoperario2';
// import VerOperario1 from './conf/veroperario1';
// import VerOperario2 from './conf/veroperario2';

import ConfFabricante1 from './conf/conffabricante1';
import ConfFabricante2 from './conf/conffabricante2';
import AddFabricante1 from './conf/addfabricante1';
import AddFabricante2 from './conf/addfabricante2';
import VerFabricante1 from './conf/verfabricante1';
import VerFabricante2 from './conf/verfabricante2';

import ConfUnidad1 from './conf/confunidad1';
import ConfUnidad2 from './conf/confunidad2';
import AddUnidad1 from './conf/addunidad1';
import AddUnidad2 from './conf/addunidad2';
import VerUnidad1 from './conf/verunidad1';
import VerUnidad2 from './conf/verunidad2';

import ConfProveed1 from './conf/confproveed1';
import ConfProveed2 from './conf/confproveed2';
import AddProveed1 from './conf/addproveed1';
import AddProveed2 from './conf/addproveed2';
import VerProveed1 from './conf/verproveed1';
import VerProveed2 from './conf/verproveed2';

import ConfProducto1 from './conf/confproducto1';
import ConfProducto2 from './conf/confproducto2';
import AddProducto1 from './conf/addproducto1';
import AddProducto2 from './conf/addproducto2';
import VerProducto1 from './conf/verproducto1';
import VerProducto2 from './conf/verproducto2';
import CargPro1 from './conf/cargpro1';
import CargPro2 from './conf/cargpro2';

import ConfMaterial1 from './conf/confmaterial1';
import ConfMaterial2 from './conf/confmaterial2';
import AddMaterial1 from './conf/addmaterial1';
import AddMaterial2 from './conf/addmaterial2';
import VerMaterial1 from './conf/vermaterial1';
import VerMaterial2 from './conf/vermaterial2';

import ConfEncuesta1 from './conf/confencuesta1';
import ConfEncuesta2 from './conf/confencuesta2';
import AddEncuesta1 from './conf/addencuesta1';
import AddEncuesta2 from './conf/addencuesta2';
import VerEncuesta1 from './conf/verencuesta1';
import VerEncuesta2 from './conf/verencuesta2';

import AdminPolitica1 from './conf/adminpolitica1';
import AdminPolitica2 from './conf/adminpolitica2';
import AddPolitica1 from './conf/addpolitica1';
import AddPolitica2 from './conf/addpolitica2';
import VerPolitica1 from './conf/verpolitica1';
import VerPolitica2 from './conf/verpolitica2';

import VerParam1 from './conf/verparam1';
import VerParam2 from './conf/verparam2';

class HomeConf extends React.Component{
  state={
    showConf: true, showUpdPro: false, 
    showEmpresa: false, addEmpresa: false, verEmpresa: false,
    showHallazgo: false, addHallazgo: false, verHallazgo: false,
    showUtilidad: false, addUtilidad: false, verUtilidad: false,
    showPrograma: false, addPrograma: false, verPrograma: false,
    showContacto: false, addContacto: false, verContacto: false,
    showOperario: false, addOperario: false, verOperario: false,
    showFabricante: false, addFabricante: false, verFabricante: false,
    showUnidad: false, addUnidad: false, verUnidad: false,
    showProveed: false, addProveed: false, verProveed: false,
    showProducto: false, addProducto: false, verProducto: false,
    showMaterial: false, addMaterial: false, verMaterial: false,
    showEncuesta: false, addEncuesta: false, verEncuesta: false,
    showPolitica: false, addPolitica: false, verPolitica: false,
    showParametro: false, argsBuscar: {}, argsBuscEmp: {}, argsBuscPro: {},
    permiteUpdate: false, permiteDelete: false,
    argsAdd: {}, errorAdd: [],
    idLista: {},
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  // ordenarArrayAsc = (array, campo) => {
  //   array.sort(function (a, b) {
  //      return a[campo] > b[campo];
  //   });
  // }

  showConf = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showConf: true})
  }
  
  showUpdPro = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showUpdPro: true})
  }


  showParametro = async (ev) => {
    ev.preventDefault()
    // let mensajeNuevo, valorMaxSinAutNuevo, nuevoNumeroOSNuevo, nuevoNumeroRCNuevo, nuevoNumeroNDNuevo, nuevoNumeroNCNuevo,
    //     nuevoNumeroAjNuevo, nuevoNumeroDXNuevo, ajCero, prefijoFact,
    //     empresaRazonSocial, empresaNit, empresaDir, empresaTel, codBarrasRdo, pagueHastaSegunSaldo,
    //     numMesesParaPH
    // if(this.props.getParametro.getParametro){
    //   if(!this.props.getParametro.getParametro.empresaRazonSocial){
    //     empresaRazonSocial = ""
    //     actualizar = true
    //   }else{
    //     empresaRazonSocial = this.props.getParametro.getParametro.empresaRazonSocial
    //   }
    //   if(!this.props.getParametro.getParametro.empresaNit){
    //     empresaNit = ""
    //     actualizar = true
    //   }else{
    //     empresaNit = this.props.getParametro.getParametro.empresaNit
    //   }
    //   if(!this.props.getParametro.getParametro.empresaDir){
    //     empresaDir = ""
    //     actualizar = true
    //   }else{
    //     empresaDir = this.props.getParametro.getParametro.empresaDir
    //   }
    //   if(!this.props.getParametro.getParametro.empresaTel){
    //     empresaTel = ""
    //     actualizar = true
    //   }else{
    //     empresaTel = this.props.getParametro.getParametro.empresaTel
    //   }

    //   if(actualizar){
    //     const argsUpd = {
    //       _id: this.props.getParametro.getParametro._id,
    //       mensaje: mensajeNuevo,
    //       valorMaxSinAut: valorMaxSinAutNuevo,
    //       nuevoNumeroOS: nuevoNumeroOSNuevo,
    //       nuevoNumeroRC: nuevoNumeroRCNuevo,
    //       nuevoNumeroND: nuevoNumeroNDNuevo,
    //       nuevoNumeroNC: nuevoNumeroNCNuevo,
    //       nuevoNumeroAj: nuevoNumeroAjNuevo,
    //       nuevoNumeroDX: nuevoNumeroDXNuevo,
    //       ajCero: ajCero,
    //       prefijoFact: prefijoFact,
    //       empresaRazonSocial: empresaRazonSocial,
    //       empresaNit: empresaNit,
    //       empresaDir: empresaDir,
    //       empresaTel: empresaTel,
    //       codBarrasRdo: codBarrasRdo,
    //       pagueHastaSegunSaldo: pagueHastaSegunSaldo,
    //       numMesesParaPH: numMesesParaPH
    //     }
        // console.log(argsUpd)
        // const response = await this.props.editParametro({
        //   variables: argsUpd
        // });
        // const {success} = response.data.editParametro;
        // if (success){
          this.props.getParametro.refetch()
        // }

      // }else{
      //   this.props.getParametro.refetch()
      // }
    // }


    this.estadosFalse()
    this.setState({showParametro: true})
  }

  showEmpresa = (ev) => {
    ev.preventDefault()
    this.props.allEmpresa.refetch()
    this.estadosFalse()
    this.setState({showEmpresa: true})
  }
  showHallazgo = (ev) => {
    ev.preventDefault()
    this.props.allHallazgo.refetch()
    this.estadosFalse()
    this.setState({showHallazgo: true})
  }  
  addHallazgo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addHallazgo: true})
  }
  showUtilidad = (ev) => {
    ev.preventDefault()
    this.props.allUtilidad.refetch()
    this.estadosFalse()
    this.setState({showUtilidad: true})
  }  
  addUtilidad = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addUtilidad: true})
  }
  showPrograma = (ev) => {
    ev.preventDefault()
    this.props.allPrograma.refetch()
    this.estadosFalse()
    this.setState({showPrograma: true})
  }  
  addPrograma = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPrograma: true})
  }
  showContacto = (ev) => {
    ev.preventDefault()
    this.props.allContacto.refetch()
    this.estadosFalse()
    this.setState({showContacto: true})
  }

  showOperario = (ev) => {
    ev.preventDefault()
    this.props.allOperario.refetch()
    this.estadosFalse()
    this.setState({showOperario: true})
  }
  showFabricante = (ev) => {
    ev.preventDefault()
    this.props.allFabricante.refetch()
    this.estadosFalse()
    this.setState({showFabricante: true})
  }

  showUnidad = (ev) => {
    ev.preventDefault()
    this.props.allUnidad.refetch()
    this.estadosFalse()
    this.setState({showUnidad: true})
  }

  showProveed = (ev) => {
    ev.preventDefault()
    this.props.allProveed.refetch()
    this.estadosFalse()
    this.setState({showProveed: true})
  }

  showProducto = (ev) => {
    ev.preventDefault()
    this.props.allProductoRtes.refetch()
    this.estadosFalse()
    this.setState({showProducto: true})
  }

  showMaterial = (ev) => {
    ev.preventDefault()
    this.props.allMaterial.refetch()
    this.estadosFalse()
    this.setState({showMaterial: true})
  }

  showEncuesta = (ev) => {
    ev.preventDefault()
    this.props.allEncuesta.refetch()
    this.estadosFalse()
    this.setState({showEncuesta: true})
  }

  showPolitica = (ev) => {
    ev.preventDefault()
    this.props.allPolitica.refetch()
    this.estadosFalse()
    this.setState({showPolitica: true})
  }
  addPolitica = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPolitica: true})
  }


  addEmpresa = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addEmpresa: true})
  }

  addContacto = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addContacto: true})
  }

  addOperario = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addOperario: true})
  }
  addFabricante = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addFabricante: true})
  }

  addUnidad = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addUnidad: true})
  }

  addProveed = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addProveed: true})
  }

  addProducto = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addProducto: true})
  }

  addMaterial = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addMaterial: true})
  }

  addEncuesta = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addEncuesta: true})
  }

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }
    //   if(input.type==='checkbox'){
    //   argsAdd[input.name] = input.checked
    // }else{
    //   argsAdd[input.name] = input.value
    // }
    this.setState({argsAdd});
  }

  handleParametro = async (ev, args)=>{
    const argsAdd = this.state.argsAdd
    const errors = [];
// console.log(args)
// console.log(this.props.getParametro.getParametro.nuevoNumeroOS)
// console.log(this.props.getParametro.getParametro)

// console.log(this.state.permiteUpdate)
    if(!args.empresaRazonSocial){
        argsAdd['empresaRazonSocial'] = "";
        errors.push({path: 'empresaRazonSocial', message: "Debe escribir el nombre de la empresa"});
        this.setState({argsAdd});
        this.setState({errorAdd: errors})
    }else{
      if(this.state.permiteUpdate){
        let argsUpd = {}

        argsUpd = {
          _id: args._id,
          mensaje: args.mensaje,
          empresaRazonSocial: args.empresaRazonSocial?args.empresaRazonSocial:"",
          empresaNit: args.empresaNit?args.empresaNit:"",
          empresaWeb: args.empresaWeb?args.empresaWeb:"",
          empresaDir1: args.empresaDir1?args.empresaDir1:"",
          empresaTel1: args.empresaTel1?args.empresaTel1:"",
          empresaCel1: args.empresaCel1?args.empresaCel1:"",
          empresaCiudad1: args.empresaCiudad1?args.empresaCiudad1:"",
          empresaDir2: args.empresaDir2?args.empresaDir2:"",
          empresaTel2: args.empresaTel2?args.empresaTel2:"",
          empresaCel2: args.empresaCel2?args.empresaCel2:"",
          empresaCiudad2: args.empresaCiudad2?args.empresaCiudad2:"",
          empresaBanco1: args.empresaBanco1?args.empresaBanco1:"",
          empresaCuenta1: args.empresaCuenta1?args.empresaCuenta1:"",
          empresaBanco2: args.empresaBanco2?args.empresaBanco2:"",
          empresaCuenta2: args.empresaCuenta2?args.empresaCuenta2:"",
          empresaPresentacion: args.empresaPresentacion?args.empresaPresentacion:"",
          empresaNombreFirma: args.empresaNombreFirma?args.empresaNombreFirma:"",
          empresaCargoFirma: args.empresaCargoFirma?args.empresaCargoFirma:"",
          empresaMailFirma: args.empresaMailFirma?args.empresaMailFirma:"",
          empresaCelFirma: args.empresaCelFirma?args.empresaCelFirma:"",
          generandoProg: args.generandoProg?args.generandoProg:"",
          trm: args.trm.replace(/\,/g,'.'),
          mailFactura: args.mailFactura,
          mailFacturaPanama: args.mailFacturaPanama,
          medidaQR: args.medidaQR,
          minimoDolar: args.minimoDolar,
          maximoDolar: args.maximoDolar,
          rango1Desde: args.rango1Desde,
          rango1Hasta: args.rango1Hasta,
          rango2Hasta: args.rango2Hasta,
          rango3Hasta: args.rango3Hasta
        }
        const response = await this.props.editParametro({
          variables: argsUpd
        });
        const {errors, success} = response.data.editParametro;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          this.props.getParametro.refetch()
          this.estadosFalse()
          this.setState({showConf: true})
        }
      }
    }
  }

  handleChangeBuscEmp = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar})
    this.handleBuscEmp(argsBuscar)
  }
  handleBuscEmp = async (args) => {
    let argsBuscar={} 
    if(args.descrEmpresa){
      argsBuscar.descrEmpresa=args.descrEmpresa
    }else{
      delete argsBuscar.descrEmpresa
    }      
    this.setState({argsBuscEmp: argsBuscar});
  }

  handleChangeBuscPro = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar})
    this.handleBuscPro(argsBuscar)
  }
  handleBuscPro = async (args) => {
    let argsBuscar={} 
    if(args.tipoProducto){
      argsBuscar.tipoProducto=args.tipoProducto
    }else{
      delete argsBuscar.tipoProducto
    }      
    if(args.marca){
      argsBuscar.marca=args.marca
    }else{
      delete argsBuscar.marca
    }
    if(args.descrProducto){
      argsBuscar.descrProducto=args.descrProducto
    }else{
      delete argsBuscar.descrProducto
    }
    if(args.estado){
      argsBuscar.estado=args.estado
    }else{
      delete argsBuscar.estado
    }
    this.setState({argsBuscPro: argsBuscar});
  }

  handleEmpresa = async (ev, args, descrEmpresaAnt)=>{
    console.log(args)
    const argsAdd = this.state.argsAdd
    const errors = [];
    if(!this.state.permiteDelete){
      if((!args.pais || args.pais==="Seleccionar...")){
        argsAdd['pais'] = "";
        errors.push({path: 'pais', message: "Debe seleccionar el país"});
      }else{
        if((!args.comercialAtiende || args.comercialAtiende==="Seleccionar...")){
          argsAdd['comercialAtiende'] = "";
          errors.push({path: 'comercialAtiende', message: "Debe seleccionar el comercial que atiende"});
        }else{
          if(!args.descrEmpresa){
            argsAdd['descrEmpresa'] = "";
            errors.push({path: 'descrEmpresa', message: "Debe escribir la descripción"});
          }
          if(!args.codEmpresa){
            argsAdd['codEmpresa'] = "";
            errors.push({path: 'codEmpresa', message: "Debe escribir el código de la empresa"});
          }else{
            if(args.codEmpresa.length!==3){
              argsAdd['codEmpresa'] = "";
              errors.push({path: 'codEmpresa', message: "El código de la empresa debe ser de 3 caracteres"});
            }else{
              let argsBuscarCod=""
              argsBuscarCod += `codEmpresa: '${args.codEmpresa}'`
              if(this.state.permiteUpdate){         
                argsBuscarCod += `, descrEmpresa: {$ne: '${descrEmpresaAnt}'}`
              }
          
              let argsBuscarEmp = {}
              argsBuscarEmp = {tipoqry: `[{$match: {${argsBuscarCod}}}]`}

              let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
              let regExiste = []

              regExiste = await data.allEmpresaRtes

              if(regExiste && regExiste.length>0){
                argsAdd['codEmpresa'] = "";
                errors.push({path: 'codEmpresa', message: "El código de la empresa ya existe"});
              }
            }
          }
        }
      }
      if(this.state.addEmpresa){
        if(!args.file){
          argsAdd['file'] = "";
          errors.push({path: 'file', message: "Debe seleccionar el archivo del logo"});
        } 
      }     
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }
    if(errors.length===0){
      if(this.state.addEmpresa){
        argsAdd['descrEmpresa'] = args.descrEmpresa.trim()      
        args.descrEmpresa = args.descrEmpresa.trim()      
        let response = await this.props.singleUpload({variables: {file: args.file}}); 
        response = await this.props.fecha({
          variables: {}
        }); 
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        args.nit = args.nit?args.nit:''
        args.rutaLogo = args.rutaLogo?args.rutaLogo:''
        args.pais = args.pais?args.pais:'Colombia'
        args.rutas = 'N'
        args.anexos = 'N'
        response = await this.props.createEmpresa({
          variables: args
        });
        const {errors, success} = response.data.createEmpresa;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          document.getElementById("file").value = ""
          var descrEmpresa = document.getElementById("descrEmpresa");
          descrEmpresa.value = ""
          var nit = document.getElementById("nit");
          nit.value = ""
          var rutaLogo = document.getElementById("rutaLogo");
          rutaLogo.value = ""
          var codEmpresa = document.getElementById("codEmpresa");
          codEmpresa.value = ""
          var direccion = document.getElementById("direccion");
          direccion.value = ""
          var telefono = document.getElementById("telefono");
          telefono.value = ""
          var comercialAtiende = document.getElementById("miLista");
          comercialAtiende.options.selectedIndex = 0
          var pais = document.getElementById("miLista1");
          pais.options.selectedIndex = 0
          // var logo = document.getElementById("logo");
          // logo.value = ""          
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allEmpresa.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          let rutas='', anexos=''
          if(args.rutas){
            if(args.rutas==='Si'){
              rutas='S'
            }else{
              rutas='N'
            }
          }else{
            rutas='N'
          }
          if(args.anexos){
            if(args.anexos==='Si'){
              anexos='S'
            }else{
              anexos='N'
            }
          }else{
            anexos='N'
          }
          const argsUpd = {
            _id: args._id,
            descrEmpresa: args.descrEmpresa,
            nit: args.nit?args.nit:'',
            rutaLogo: args.rutaLogo?args.rutaLogo:'',
            comercialAtiende: args.comercialAtiende?args.comercialAtiende:'',
            ciudad: args.ciudad?args.ciudad:'',
            pais: args.pais?args.pais:'Colombia',
            codEmpresa: args.codEmpresa,
            descrEmpresaAnt: descrEmpresaAnt,
            direccion: args.direccion,
            telefono: args.telefono,
            logo: args.logo,
            rut: args.rut,
            camara: args.camara,
            rutas: rutas,
            anexos: anexos,
            modLogo: 'N',
            modRut: 'N',
            modCamara: 'N',
            tipoAct: 'EditarEmpresa'
          }

          if(args.file!==null && args.file!==''){
            argsUpd.modLogo = 'S'
            let response = await this.props.singleUpload({variables: {file: args.file}}); 
          } 
          if(args.file1!==null && args.file1!==''){
            argsUpd.modRut = 'S'
            let response = await this.props.singleUpload({variables: {file: args.file1}}); 
          }
          if(args.file2!==null && args.file2!==''){
            argsUpd.modCamara = 'S'
            let response = await this.props.singleUpload({variables: {file: args.file2}}); 
          }
          console.log(argsUpd)
          const response = await this.props.editEmpresa({
            variables: argsUpd
          });
          const {errors, success} = response.data.editEmpresa;
          // console.log(errors, success)
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            document.getElementById("file").value = ""
            this.props.allEmpresa.refetch()
            this.estadosFalse()
            this.setState({showEmpresa: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteEmpresa({
            variables: argsDel
          });
          this.props.allEmpresa.refetch()
          this.estadosFalse()
          this.setState({showEmpresa: true})
        }
      }
    }
  }

  handleHallazgo = async (ev, args, descrHallazgoAnt)=>{
    if((!args.descrHallazgo) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrHallazgo){
        argsAdd['descrHallazgo'] = "";
        errors.push({path: 'descrHallazgo', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addHallazgo){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createHallazgo({
          variables: args
        });
        const {errors, success} = response.data.createHallazgo;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrHallazgo = document.getElementById("descrHallazgo");
          descrHallazgo.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allHallazgo.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrHallazgo: args.descrHallazgo,
            descrHallazgoAnt: descrHallazgoAnt,
          }
          const response = await this.props.editHallazgo({
            variables: argsUpd
          });
          const {errors, success} = response.data.editHallazgo;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allHallazgo.refetch()
            this.estadosFalse()
            this.setState({showHallazgo: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteHallazgo({
            variables: argsDel
          });
          this.props.allHallazgo.refetch()
          this.estadosFalse()
          this.setState({showHallazgo: true})
        }
      }
    }
  }

  handleUtilidad = async (ev, args, descrUtilidadAnt)=>{
    if((!args.descrUtilidad) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrUtilidad){
        argsAdd['descrUtilidad'] = "";
        errors.push({path: 'descrUtilidad', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addUtilidad){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createUtilidad({
          variables: args
        });
        const {errors, success} = response.data.createUtilidad;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrUtilidad = document.getElementById("descrUtilidad");
          descrUtilidad.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allUtilidad.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrUtilidad: args.descrUtilidad,
            descrUtilidadAnt: descrUtilidadAnt,
          }
          const response = await this.props.editUtilidad({
            variables: argsUpd
          });
          const {errors, success} = response.data.editUtilidad;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allUtilidad.refetch()
            this.estadosFalse()
            this.setState({showUtilidad: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteUtilidad({
            variables: argsDel
          });
          this.props.allUtilidad.refetch()
          this.estadosFalse()
          this.setState({showUtilidad: true})
        }
      }
    }
  }

  handlePrograma = async (ev, args, descrProgramaAnt)=>{
    if((!args.descrPrograma) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrPrograma){
        argsAdd['descrPrograma'] = "";
        errors.push({path: 'descrPrograma', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPrograma){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        console.log(args)
        response = await this.props.createPrograma({
          variables: args
        });
        const {errors, success} = response.data.createPrograma;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrPrograma = document.getElementById("descrPrograma");
          descrPrograma.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPrograma.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrPrograma: args.descrPrograma,
            descrProgramaAnt: descrProgramaAnt,
          }
          const response = await this.props.editPrograma({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPrograma;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPrograma.refetch()
            this.estadosFalse()
            this.setState({showPrograma: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deletePrograma({
            variables: argsDel
          });
          this.props.allPrograma.refetch()
          this.estadosFalse()
          this.setState({showPrograma: true})
        }
      }
    }
  }

  handleContacto = async (ev, args, nombreContactoAnt)=>{
    console.log(args)
    if((!args.nombreContacto) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.nombreContacto){
        argsAdd['nombreContacto'] = "";
        errors.push({path: 'nombreContacto', message: "Debe escribir el nombre del contacto"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addContacto){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createContacto({
          variables: args
        });
        const {errors, success} = response.data.createContacto;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrEmpresa = document.getElementById("miLista");
          descrEmpresa.options.selectedIndex = 0
          var nombreContacto = document.getElementById("nombreContacto");
          nombreContacto.value = ""
          var ciudadContacto = document.getElementById("ciudadContacto");
          ciudadContacto.value = ""
          var cargoContacto = document.getElementById("cargoContacto");
          cargoContacto.value = ""
          var mailContacto = document.getElementById("mailContacto");
          mailContacto.value = ""
          var telContacto = document.getElementById("telContacto");
          telContacto.value = ""
          // logo.value = ""          
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allEmpresa.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          console.log(args.file)
          const argsUpd = {
            _id: args._id,
            descrEmpresa: args.descrEmpresa,
            nombreContacto: args.nombreContacto,
            nombreContactoAnt: nombreContactoAnt,
            ciudadContacto: args.ciudadContacto,
            cargoContacto: args.cargoContacto,
            mailContacto: args.mailContacto,
            telContacto: args.telContacto,
          }

          const response = await this.props.editContacto({
            variables: argsUpd
          });
          const {errors, success} = response.data.editContacto;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allContacto.refetch()
            this.estadosFalse()
            this.setState({showContacto: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteContacto({
            variables: argsDel
          });
          this.props.allContacto.refetch()
          this.estadosFalse()
          this.setState({showContacto: true})
        }
      }
    }
  }


  handleOperario = async (ev, args, descrOperarioAnt, cedulaAnt)=>{
    // console.log(descrEmpresaAnt)
    if((!args.descrOperario || !args.cedula) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrOperario){
        argsAdd['descrOperario'] = "";
        errors.push({path: 'descrOperario', message: "Debe escribir la descripción"});
      }
      if(!args.cedula){
        argsAdd['cedula'] = "";
        errors.push({path: 'cedula', message: "Debe escribir la cedula"});
      }      
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addOperario){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createOperario({
          variables: args
        });
        const {errors, success} = response.data.createOperario;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrOperario = document.getElementById("descrOperario");
          descrOperario.value = ""
          var cedula = document.getElementById("cedula");
          cedula.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allOperario.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrOperario: args.descrOperario,
            descrOperarioAnt: descrOperarioAnt,
            cedula: args.cedula,
            cedulaAnt: args.cedulaAnt,
          }
          const response = await this.props.editOperario({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOperario;
          // console.log(errors, success)
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allOperario.refetch()
            this.estadosFalse()
            this.setState({showOperario: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteOperario({
            variables: argsDel
          });
          this.props.allOperario.refetch()
          this.estadosFalse()
          this.setState({showOperario: true})
        }
      }
    }
  }

  handleFabricante = async (ev, args)=>{
    if((!args.descrFabricante) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrFabricante){
        argsAdd['descrFabricante'] = "";
        errors.push({path: 'descrFabricante', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addFabricante){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createFabricante({
          variables: args
        });
        const {errors, success} = response.data.createFabricante;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrFabricante = document.getElementById("descrFabricante");
          descrFabricante.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allFabricante.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrFabricante: args.descrFabricante,
          }
          const response = await this.props.editFabricante({
            variables: argsUpd
          });
          const {errors, success} = response.data.editFabricante;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allFabricante.refetch()
            this.estadosFalse()
            this.setState({showFabricante: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteFabricante({
            variables: argsDel
          });
          this.props.allFabricante.refetch()
          this.estadosFalse()
          this.setState({showFabricante: true})
        }
      }
    }
  }

  handleUnidad = async (ev, args, descrUnidadAnt, abrevUnidadAnt)=>{
    if((!args.tipoUnidad||!args.descrUnidad||!args.abrevUnidad) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoUnidad||args.tipoUnidad==="Seleccionar..."){
        argsAdd['tipoUnidad'] = "Seleccionar...";
        errors.push({path: 'tipoUnidad', message: "Debe seleccionar el tipo de unidad"});
      }
      if(!args.descrUnidad){
        argsAdd['descrUnidad'] = "";
        errors.push({path: 'descrUnidad', message: "Debe escribir la descripción"});
      }
      if(!args.abrevUnidad){
        argsAdd['abrevUnidad'] = "";
        errors.push({path: 'abrevUnidad', message: "Debe escribir la abreviatura"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addUnidad){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createUnidad({
          variables: args
        });
        const {errors, success} = response.data.createUnidad;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrUnidad = document.getElementById("descrUnidad");
          var abrevUnidad = document.getElementById("abrevUnidad");
          var tipoUnidad = document.getElementById("miLista");
          tipoUnidad.options.selectedIndex = 0        
          descrUnidad.value = ""
          abrevUnidad.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allUnidad.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoUnidad: args.tipoUnidad,
            descrUnidad: args.descrUnidad,
            abrevUnidad: args.abrevUnidad,
            descrUnidadAnt: descrUnidadAnt,
            abrevUnidadAnt: abrevUnidadAnt,            
          }
          const response = await this.props.editUnidad({
            variables: argsUpd
          });
          const {errors, success} = response.data.editUnidad;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allUnidad.refetch()
            this.estadosFalse()
            this.setState({showUnidad: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteUnidad({
            variables: argsDel
          });
          this.props.allUnidad.refetch()
          this.estadosFalse()
          this.setState({showUnidad: true})
        }
      }
    }
  }

  handleProveed = async (ev, args, descrProveedAnt, numeroDocumentoAnt)=>{
    if((!args.descrDocumento||!args.descrProveed) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrDocumento||args.descrDocumento==="Seleccionar..."){
        argsAdd['descrDocumento'] = "Seleccionar...";
        errors.push({path: 'descrDocumento', message: "Debe seleccionar el tipo de documento"});
      }
      if(!args.descrProveed){
        argsAdd['descrProveed'] = "";
        errors.push({path: 'descrProveed', message: "Debe escribir la descripción"});
      }
      // if(!args.numeroDocumento){
      //   argsAdd['numeroDocumento'] = "";
      //   errors.push({path: 'numeroDocumento', message: "Debe escribir el número del documento"});
      // }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addProveed){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        args.consecCoti = 0
        args.numeroDocumento = args.numeroDocumento?args.numeroDocumento:''
        response = await this.props.createProveed({
          variables: args
        });
        const {errors, success} = response.data.createProveed;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrProveed = document.getElementById("descrProveed");
          var numeroDocumento = document.getElementById("numeroDocumento");
          var descrDocumento = document.getElementById("miLista");
          var ciudad = document.getElementById("ciudad");
          var direccion = document.getElementById("direccion");
          var telefono = document.getElementById("telefono");
          var email = document.getElementById("email");
          var contacto = document.getElementById("contacto");
          descrDocumento.options.selectedIndex = 0        
          descrProveed.value = ""
          numeroDocumento.value = ""
          ciudad.value = ""
          direccion.value = ""
          telefono.value = ""
          email.value = ""
          contacto.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allProveed.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrDocumento: args.descrDocumento,
            descrProveed: args.descrProveed,
            numeroDocumento: args.numeroDocumento,
            descrProveedAnt: descrProveedAnt,
            numeroDocumentoAnt: numeroDocumentoAnt,            
            ciudad: args.ciudad,
            direccion: args.direccion,
            telefono: args.telefono,
            email: args.email,
            contacto: args.contacto,
            tipoAct: 'EditarPr'
          }
          console.log(argsUpd)
          const response = await this.props.editProveed({
            variables: argsUpd
          });
          
          const {errors, success} = response.data.editProveed;
          
          if (!success){
            console.log(errors)
            this.setState({errorAdd: errors})
          }else{
            this.props.allProveed.refetch()
            this.estadosFalse()
            this.setState({showProveed: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteProveed({
            variables: argsDel
          });
          this.props.allProveed.refetch()
          this.estadosFalse()
          this.setState({showProveed: true})
        }
      }
    }
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleProducto = async (ev, args, descrProductoAnt)=>{ 
    const a251020 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251020" );
    const a251030 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251030" );
    const errors = [];

    if((localStorage.getItem('userLogin')!=="slcm@slcm.com") && (((!args.tipoProducto || !args.tipoOrden || !args.descrProducto || !args.descrCorta || !args.descrUnidad||args.descrUnidad==="Seleccionar..." 
    || args.costo===0 || args.margen===0 || !args.monedaCosto||args.monedaCosto==="Seleccionar..." 
    || (args.tipoProducto==="Producto" && !args.marca)) && !this.state.permiteDelete)||
    ((args.descrProducto==="Transporte" || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte')&&this.state.permiteDelete)
    || (a251020!==-1 && args.descrProducto!=="Transporte" && args.descrProducto!=='Transporte producto' && args.descrProducto!=='Alojamiento, alimentación y transporte' && this.state.permiteUpdate)
    || (a251020!==-1 && this.state.permiteDelete))){
      console.log("INICIA UPDATE")
      const argsAdd = this.state.argsAdd
      if(!args.tipoProducto||args.tipoProducto==="Seleccionar..."){
        argsAdd['tipoProducto'] = "Seleccionar...";
        errors.push({path: 'tipoProducto', message: "Debe seleccionar el tipo de producto"});
      }
      if(!args.tipoOrden||args.tipoOrden==="Seleccionar..."){
        argsAdd['tipoOrden'] = "Seleccionar...";
        errors.push({path: 'tipoOrden', message: "Debe seleccionar el tipo de orden"});
      }
      if(!args.descrUnidad||args.descrUnidad==="Seleccionar..."){
        argsAdd['descrUnidad'] = "Seleccionar...";
        errors.push({path: 'descrUnidad', message: "Debe seleccionar la unidad"});
      }
      if(!args.monedaCosto||args.monedaCosto==="Seleccionar..."){
        argsAdd['monedaCosto'] = "Seleccionar...";
        errors.push({path: 'monedaCosto', message: "Debe seleccionar la moneda del costo"});
      }
      if(!args.descrProducto){
        argsAdd['descrProducto'] = "";
        errors.push({path: 'descrProducto', message: "Debe escribir la descripción"});
      }
      if(!args.descrCorta){
        argsAdd['descrCorta'] = "";
        errors.push({path: 'descrCorta', message: "Debe escribir la descripción corta"});
      }
      if(((!args.costo || args.costo===0))&&(args.descrProducto!=="Transporte" || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte')){
        argsAdd['costo'] = "";
        errors.push({path: 'costo', message: "Debe escribir el costo"});
      }
      if(((!args.margen || args.margen===0))&&(args.descrProducto!=="Transporte" || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte')){
        argsAdd['margen'] = "";
        errors.push({path: 'margen', message: "Debe escribir el margen"});
      }
      if((args.descrProducto==="Transporte" || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte')&&this.state.permiteDelete){ 
        argsAdd['descrProducto'] = "";
        errors.push({path: 'descrProducto', message: "No es posible eliminar este producto" });
      }
      if(args.tipoProducto!=="Producto"){
        argsAdd['marca'] = "";
      }else{
        if(!args.marca){
          argsAdd['marca'] = "";
          errors.push({path: 'marca', message: "Debe escribir la marca del producto"});
        }      
      }
      if(localStorage.getItem('userLogin')!=="slcm@slcm.com" && a251020!==-1 && args.descrProducto!=="Transporte" && args.descrProducto!=='Transporte producto' && args.descrProducto!=='Alojamiento, alimentación y transporte' && this.state.permiteUpdate){
        argsAdd['descrProducto'] = "";
        errors.push({path: 'descrProducto', message: "Este usuario solo está autorizado para modificar los transportes" });
      }
      if(localStorage.getItem('userLogin')!=="slcm@slcm.com" && a251020!==-1 && this.state.permiteDelete){
        argsAdd['descrProducto'] = "";
        errors.push({path: 'descrProducto', message: "Este usuario no está autorizado para eliminar registros en esta opción" });
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addProducto){
        let numProducto = await this.nextVal('producto')
        args.numProducto=numProducto

        if(!args.porcIVA){
          args.porcIVA = 0;
        }
        if(!args.margen){
          args.margen = 0;
        }
        if(!args.costo){
          args.costo = 0;
        }
        if(!args.precio){
          args.precio = 0;
        }
        if(!args.precioDolar){
          args.precioDolar = 0;
        }
        if(!args.porcImpto){
          args.porcImpto = 0;
        }
        if(!args.comisionRango1){
          args.comisionRango1 = 0;
        }
        if(!args.comisionRango2){
          args.comisionRango2 = 0;
        }
        if(!args.comisionRango3){
          args.comisionRango3 = 0;
        }
        if(!args.comisionExt){
          args.comisionExt = 0;
        }
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        if(!args.file){ 
          args['file'] = "";
        }else{
          args['file'] = args.file;
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
        }
        if(!args.file1){
          args['file1'] = "";
        }else{
          args['file1'] = args.file1;
          let response = await this.props.singleUpload({variables: {file: args.file1}}); 
        }     


        args['modArch1'] = 'N';
        args['modArch2'] = 'N';

        if(args.file!==null && args.file!==''){
          args['modArch1'] = "S"
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
        }else{
          args['file'] = ""
        }
        if(args.file1!==null && args.file1!==''){
          args['modArch2'] = "S"
          args['file1'] = ""
          let response = await this.props.singleUpload({variables: {file: args.file1}}); 
        }else{
          args['file1'] = ""
        }
        args['estado'] = "Activo"
        args['esLubricante'] = "P"
        response = await this.props.createProducto({
          variables: args 
        });
        console.log(args)
        const {errors, success} = response.data.createProducto;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrProducto = document.getElementById("descrProducto");
          var descrCorta = document.getElementById("descrCorta");
          var codigo = document.getElementById("codigo");
          var marca = document.getElementById("marca");
          var tipoProducto = document.getElementById("miLista1");
          var tipoOrden = document.getElementById("miLista3");
          var descrUnidad = document.getElementById("miLista8");
          var monedaCosto = document.getElementById("miLista55");
          var costo = document.getElementById("costo");
          var precio = document.getElementById("precio");
          var porcIVA = document.getElementById("porcIVA");
          var margen = document.getElementById("margen");
          var precioDolar = document.getElementById("precioDolar");
          var porcImpto = document.getElementById("porcImpto");
          var comisionRango1 = document.getElementById("comisionRango1");
          var comisionRango2 = document.getElementById("comisionRango2");
          var comisionRango3 = document.getElementById("comisionRango3");
          var comisionExt = document.getElementById("comisionExt");
          tipoProducto.options.selectedIndex = 0   
          tipoOrden.options.selectedIndex = 0   
          descrUnidad.options.selectedIndex = 0    
          monedaCosto.options.selectedIndex = 0       
          descrProducto.value = ""
          descrCorta.value = ""
          codigo.value = ""
          marca.value = ""
          costo.value = 0
          precio.value = 0
          porcIVA.value = 0
          margen.value = 0
          precioDolar.value = 0
          porcImpto.value = 0
          comisionRango1.value = 0
          comisionRango2.value = 0
          comisionRango3.value = 0
          comisionExt.value = 0
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allProductoRtes.refetch()
        }
      }else{
        console.log(args)
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoProducto: args.tipoProducto,
            tipoOrden: args.tipoOrden,
            descrProducto: args.descrProducto,
            descrCorta: args.descrCorta,
            codigo: args.codigo?args.codigo:'',
            esLubricante: 'P',
            marca: args.marca,
            ficha: args.ficha,
            ficha2: args.ficha2,
            costo: args.costo?args.costo:0,
            monedaCosto: args.monedaCosto?args.monedaCosto:'',
            precio: args.precio?args.precio:0,
            precioDolar: args.precioDolar?args.precioDolar:0,
            vigenteHasta: args.vigenteHasta,
            descrUnidad: args.descrUnidad,
            porcIVA: args.porcIVA?args.porcIVA:0,
            margen: args.margen?args.margen:0,
            porcImpto: args.porcImpto?args.porcImpto:0,
            comisionRango1: args.comisionRango1?args.comisionRango1:0,
            comisionRango2: args.comisionRango2?args.comisionRango2:0,
            comisionRango3: args.comisionRango3?args.comisionRango3:0,
            comisionExt: args.comisionExt?args.comisionExt:0,
            modArch1: "N",
            modArch2: "N",
            descrProductoAnt: descrProductoAnt,
            estado: args.estado?args.estado:'Activo'
          }

          if(args.file!==null && args.file!==''){
            argsUpd.modArch1 = "S"
            let response = await this.props.singleUpload({variables: {file: args.file}}); 
          }
          if(args.file1!==null && args.file1!==''){
            argsUpd.modArch2 = "S"
            let response = await this.props.singleUpload({variables: {file: args.file1}}); 
          }
          console.log(argsUpd)
          const response = await this.props.editProducto({
            variables: argsUpd
          });
          const {errors, success} = response.data.editProducto;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allProductoRtes.refetch()
            this.estadosFalse()
            this.setState({showProducto: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteProducto({
            variables: argsDel
          });
          this.props.allProductoRtes.refetch()
          this.estadosFalse()
          this.setState({showProducto: true})
        }
      }
    }
  }

  handleMaterial = async (ev, args, descrMaterialAnt, codMaterialAnt)=>{
    if((!args.tipoMaterial||!args.descrMaterial||!args.codMaterial) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoMaterial||args.tipoMaterial==="Seleccionar..."){
        argsAdd['tipoMaterial'] = "Seleccionar...";
        errors.push({path: 'tipoMaterial', message: "Debe seleccionar el tipo de material"});
      }
      if(!args.descrMaterial){
        argsAdd['descrMaterial'] = "";
        errors.push({path: 'descrMaterial', message: "Debe escribir la descripción"});
      }
      if(!args.codMaterial){
        argsAdd['codMaterial'] = "";
        errors.push({path: 'codMaterial', message: "Debe escribir el código"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addMaterial){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createMaterial({
          variables: args
        });
        const {errors, success} = response.data.createMaterial;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrMaterial = document.getElementById("descrMaterial");
          var codMaterial = document.getElementById("codMaterial");
          var tipoMaterial = document.getElementById("miLista");
          tipoMaterial.options.selectedIndex = 0        
          descrMaterial.value = ""
          codMaterial.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allMaterial.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoMaterial: args.tipoMaterial,
            descrMaterial: args.descrMaterial,
            codMaterial: args.codMaterial,
            descrMaterialAnt: descrMaterialAnt,
            codMaterialAnt: codMaterialAnt,            
          }
          const response = await this.props.editMaterial({
            variables: argsUpd
          });
          const {errors, success} = response.data.editMaterial;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allMaterial.refetch()
            this.estadosFalse()
            this.setState({showMaterial: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteMaterial({
            variables: argsDel
          });
          this.props.allMaterial.refetch()
          this.estadosFalse()
          this.setState({showMaterial: true})
        }
      }
    }
  }

  handleEncuesta = async (ev, args)=>{
    if((!args.pregunta) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.pregunta){
        argsAdd['pregunta'] = "";
        errors.push({path: 'pregunta', message: "Debe escribir la pregunta"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addEncuesta){
        const response = await this.props.createEncuesta({
          variables: args
        });
        const {errors, success} = response.data.createEncuesta;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var pregunta = document.getElementById("pregunta");
          pregunta.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allEncuesta.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            pregunta: args.pregunta,
          }
          const response = await this.props.editEncuesta({
            variables: argsUpd
          });
          const {errors, success} = response.data.editEncuesta;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allEncuesta.refetch()
            this.estadosFalse()
            this.setState({showEncuesta: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteEncuesta({
            variables: argsDel
          });
          this.props.allEncuesta.refetch()
          this.estadosFalse()
          this.setState({showEncuesta: true})
        }
      }
    }
  }

  handlePolitica = async (ev, args, tituloAnt)=>{
    console.log(args)
    if((!args.titulo || !args.descrPolitica) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.titulo){
        argsAdd['titulo'] = "";
        errors.push({path: 'titulo', message: "Debe escribir el nombre de la política"});
      }
      if(!args.descrPolitica){
        argsAdd['descrPolitica'] = "";
        errors.push({path: 'descrPolitica', message: "Debe escribir el detalle de la política"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPolitica){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createPolitica({
          variables: args
        });
        const {errors, success} = response.data.createPolitica;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var titulo = document.getElementById("titulo");
          var descrPolitica = document.getElementById("descrPolitica");
          var titulo2 = document.getElementById("titulo2");
          var parrafo2 = document.getElementById("parrafo2");
          var titulo3 = document.getElementById("titulo3");
          var parrafo3 = document.getElementById("parrafo3");
          var tipoProducto = document.getElementById("miLista");
          tipoProducto.options.selectedIndex = 0
          titulo.value = ""
          descrPolitica.value = ""
          titulo2.value = ""
          parrafo2.value = ""
          titulo3.value = ""
          parrafo3.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPolitica.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            titulo: args.titulo,
            descrPolitica: args.descrPolitica,
            titulo2: args.titulo2,
            parrafo2: args.parrafo2,
            titulo3: args.titulo3,
            parrafo3: args.parrafo3,
            tipoProducto: args.tipoProducto,
            tituloAnt: tituloAnt,
          }
          const response = await this.props.editPolitica({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPolitica;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPolitica.refetch()
            this.estadosFalse()
            this.setState({showPolitica: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deletePolitica({
            variables: argsDel
          });
          this.props.allPolitica.refetch()
          this.estadosFalse()
          this.setState({showPolitica: true})
        }
      }
    }
  }

  handleSelTipoUnidad = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoUnidad'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelDescrDocumento = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrDocumento'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelDescrEmpresa = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelTipoProducto = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoProducto'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }
  handleSelTipoOrden = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoOrden'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelTipoMaterial = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoMaterial'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSeltipoLub = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelDescrUnidad = () => {
    var miLista = document.getElementById("miLista8");
    const argsAdd = this.state.argsAdd
    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].text
    argsAdd['abrevUnidad'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  } 

  handleSelDescrLubricante = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrLubricante'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSelMoneda = () => {
    var miLista = document.getElementById("miLista55");
    const argsAdd = this.state.argsAdd
    argsAdd['monedaCosto'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSelcomercialAtiende = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['comercialAtiende'] = miLista.options[miLista.selectedIndex].text

    this.setState({argsAdd});
  }
  handleSelPais = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['pais'] = miLista.options[miLista.selectedIndex].text

    this.setState({argsAdd});
  }

  crudBD = async (operacionCRUD, args)=>{
//ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
//ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0])
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0])
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i])
    }
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    // console.log(this.state)
    this.setState({idLista: idLista})

    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showEmpresa) {
      this.setState({verEmpresa: true})
    }
    if (this.state.showHallazgo) {
      this.setState({verHallazgo: true})
    }   
    if (this.state.showUtilidad) {
      this.setState({verUtilidad: true})
    }
    if (this.state.showPrograma) {
      this.setState({verPrograma: true})
    }
    if (this.state.showContacto) {
      this.setState({verContacto: true})
    }
    if (this.state.showOperario) {
      this.setState({verOperario: true})
    }    
    if (this.state.showFabricante) {
      this.setState({verFabricante: true})
    }
    if (this.state.showUnidad) {
      this.setState({verUnidad: true})
    }
    if (this.state.showProveed) {
      this.setState({verProveed: true})
    }
    if (this.state.showProducto) {
      this.setState({verProducto: true})
    }
    if (this.state.showMaterial) {
      this.setState({verMaterial: true})
    }
    if (this.state.showEncuesta) {
      this.setState({verEncuesta: true})
    }
    if (this.state.showPolitica) {
      this.setState({verPolitica: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  showDescProducto = async () => {

    let argsBuscarIt = {}


    const a251025 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251025" );

    // let {data} = await this.props.allLubricante.refetch()
    // let productos = await data.allLubricante
    // productos = productos.filter(elemento => elemento.esLubricante==='P')
    let {data} = await this.props.allProductoRtes.refetch()
    let productos = await data.allProductoRtes
    // console.log(estructura)
  
    if(productos.length>0){
  //Archivo Excel
      let xlsString = []
      let listRtes = productos
      let xlsString1 = []
      xlsString1 = ['ID', 'Num producto', 'Tipo de producto', 'Tipo de orden', 'Descripción', 'Código', 'Lubricante asociado', 'Marca', 'Costo', 'Moneda costo', 'Precio en $', 'Precio en $US', 'Fecha de vigencia de precio', 'Unidad', '% IVA', '% ITBMS', 'Estado (Activo / Inactivo)', 'Comisión rango 1', 'Comisión rango 2', 'Comisión rango 3', 'Comisión externos', 'Margen de utilidad', 'NUEVA DESCRIPCION']    
      xlsString.push(xlsString1)
  
      for(let i=0; i<listRtes.length; i++){
        let vigenteHasta = ''
        let campoAgno = ''
        let campoMes = ''
        let campoDia= ''
        if(listRtes[i].vigenteHasta){
          campoAgno = listRtes[i].vigenteHasta.substring(0, 4)
          campoMes = listRtes[i].vigenteHasta.substring(5, 7)
          campoDia = listRtes[i].vigenteHasta.substring(8, 10)
          if(campoDia!==null && campoDia!=='' && campoMes!==null && campoMes!=='' && campoAgno!==null && campoAgno!==''){
            vigenteHasta = campoAgno + '-' + campoMes + '-' + campoDia
          }
        }
        if(a251025!==-1){
          xlsString1 = [listRtes[i]._id, listRtes[i].numProducto?listRtes[i].numProducto:0, listRtes[i].tipoProducto, listRtes[i].tipoOrden?listRtes[i].tipoOrden:'', 
          listRtes[i].descrProducto, listRtes[i].codigo?listRtes[i].codigo:'', listRtes[i].descrLubricante?listRtes[i].descrLubricante:'NINGUNO',
          listRtes[i].marca, listRtes[i].costo?listRtes[i].costo:0, listRtes[i].monedaCosto?listRtes[i].monedaCosto:'', listRtes[i].precio, 
          listRtes[i].precioDolar?listRtes[i].precioDolar:0, vigenteHasta, 
          listRtes[i].descrUnidad, listRtes[i].porcIVA, listRtes[i].porcImpto?listRtes[i].porcImpto:0, 
          listRtes[i].estado?listRtes[i].estado:'Activo', listRtes[i].comisionRango1?listRtes[i].comisionRango1:0, 
          listRtes[i].comisionRango2?listRtes[i].comisionRango2:0, listRtes[i].comisionRango3?listRtes[i].comisionRango3:0, 
          listRtes[i].comisionExt?listRtes[i].comisionExt:0, listRtes[i].margen?listRtes[i].margen:0, listRtes[i].descrProducto]
          xlsString.push(xlsString1)
        }else{
          xlsString1 = [listRtes[i]._id, listRtes[i].numProducto?listRtes[i].numProducto:0, listRtes[i].tipoProducto, listRtes[i].tipoOrden?listRtes[i].tipoOrden:'', 
          listRtes[i].descrProducto, listRtes[i].codigo?listRtes[i].codigo:'', listRtes[i].descrLubricante?listRtes[i].descrLubricante:'NINGUNO',
          listRtes[i].marca, 0, '', 0, 0, vigenteHasta, 
          listRtes[i].descrUnidad, listRtes[i].porcIVA, listRtes[i].porcImpto?listRtes[i].porcImpto:0, 
          listRtes[i].estado?listRtes[i].estado:'Activo', 0, 0, 0, listRtes[i].descrProducto]
          xlsString.push(xlsString1)
        }
      }
  
      var wb = XLSX.utils.book_new();
  
      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };
  
      wb.SheetNames.push("Productos");
  
      let ws_data = xlsString;
  
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Productos"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Productos.xlsx');
    }
  }

  componentDidUpdate(prevProps){

  }

  render(){
    const {showConf, showEmpresa, addEmpresa, verEmpresa, showContacto, addContacto, verContacto,
      showHallazgo, addHallazgo, verHallazgo, showOperario, addOperario, verOperario, showUpdPro,
      showFabricante, addFabricante, verFabricante, showUtilidad, addUtilidad, verUtilidad, 
      showUnidad, addUnidad, verUnidad, showPrograma, addPrograma, verPrograma, 
      showProveed, addProveed, verProveed,
      showProducto, addProducto, verProducto,
      showMaterial, addMaterial, verMaterial,
      showEncuesta, addEncuesta, verEncuesta,
      showPolitica, addPolitica, verPolitica, 
      showParametro, argsBuscar, argsBuscEmp, argsBuscPro,
      permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista} = this.state;        

    let lista = []
    let lista11 = []
    let lista12 = []

    if (this.state.showParametro) {
      if(this.props.getParametro.getParametro){lista = this.props.getParametro.getParametro}
    }
    if (this.state.showEmpresa || this.state.showContacto || this.state.addContacto || this.state.verContacto) {
      if(this.props.allEmpresa.allEmpresa){lista = this.props.allEmpresa.allEmpresa}
      console.log(lista)
    }
    if (this.state.verEmpresa) {
      if(this.props.allUsuariosRtes2.allUsuariosRtes){lista = this.props.allUsuariosRtes2.allUsuariosRtes}
    }
    if (this.state.showHallazgo) {
      if(this.props.allHallazgo.allHallazgo){lista = this.props.allHallazgo.allHallazgo}
    }
    if (this.state.showUtilidad) {
      if(this.props.allUtilidad.allUtilidad){lista = this.props.allUtilidad.allUtilidad}
    }
    if (this.state.showPrograma) {
      if(this.props.allPrograma.allPrograma){lista = this.props.allPrograma.allPrograma}
    }
    if (this.state.showOperario) {
      if(this.props.allOperario.allOperario){lista = this.props.allOperario.allOperario}
    }    
    if (this.state.showFabricante) {
      if(this.props.allFabricante.allFabricante){lista = this.props.allFabricante.allFabricante}
    }
    if (this.state.showUnidad) {
      if(this.props.allUnidad.allUnidad){lista = this.props.allUnidad.allUnidad}
    }
    if (this.state.showProveed) {
      if(this.props.allProveed.allProveed){lista = this.props.allProveed.allProveed}
    }
    if (this.state.showProducto) {
      if(this.props.allProductoRtes.allProductoRtes){
        lista = this.props.allProductoRtes.allProductoRtes
        // lista = lista.filter(elemento => elemento.esLubricante==='P')
      }
    }
    if (this.state.addProducto || this.state.verProducto) {
      if(this.props.allUnidad.allUnidad){lista11 = this.props.allUnidad.allUnidad}
      if(this.props.allLubricante.allLubricante){lista12 = this.props.allLubricante.allLubricante}

      console.log(lista12)
    }
    if (this.state.showMaterial) {
      if(this.props.allMaterial.allMaterial){lista = this.props.allMaterial.allMaterial}
    }
    if (this.state.showEncuesta) {
      if(this.props.allEncuesta.allEncuesta){lista = this.props.allEncuesta.allEncuesta}
    }
    if (this.state.showPolitica) {
      if(this.props.allPolitica.allPolitica){lista = this.props.allPolitica.allPolitica}
    }

    let fechaHasta = parseInt((new Date().getTime() + (1000*60*60*24)*30), 10)
    fechaHasta = new Date(fechaHasta)
    fechaHasta = (fechaHasta.getFullYear()) + '-' + ((fechaHasta.getMonth()+1)<10?'0'+(fechaHasta.getMonth()+1):(fechaHasta.getMonth()+1)) + '-' + (fechaHasta.getUTCDate()<10?'0'+fechaHasta.getUTCDate():fechaHasta.getUTCDate())


    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showConf && <HomeConf1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                          handleClickSel11={this.showEmpresa} 
                          // handleClickSel23={this.showOperario} 
                          handleClickSel21={this.showUnidad}  handleClickSel12={this.showProveed} 
                          handleClickSel13={this.showProducto} handleClickSel14={this.showMaterial}
                          handleClickSel22={this.showParametro} handleClickSel15={this.showHallazgo}
                          handleClickSel16={this.showEncuesta} handleClickSel17={this.showPolitica}
                          handleClickSel18={this.showUtilidad} handleClickSel23={this.showPrograma}/>}

            {showEmpresa && <ConfEmpresa1 styles={this.props.styles} handleClickRegr={this.showConf}
                        handleChange={this.handleChangeBuscEmp} handleSubmit={this.handleBuscEmp}
                        args={argsBuscar}/>}
           
            {addEmpresa && <AddEmpresa1 styles={this.props.styles} handleClickRegr={this.showEmpresa}/>}
            {verEmpresa && <VerEmpresa1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showEmpresa} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showHallazgo && <ConfHallazgo1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addHallazgo && <AddHallazgo1 styles={this.props.styles} handleClickRegr={this.showHallazgo}/>}
            {verHallazgo && <VerHallazgo1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showHallazgo} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showUtilidad && <ConfUtilidad1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addUtilidad && <AddUtilidad1 styles={this.props.styles} handleClickRegr={this.showUtilidad}/>}
            {verUtilidad && <VerUtilidad1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showUtilidad} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showPrograma && <ConfPrograma1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addPrograma && <AddPrograma1 styles={this.props.styles} handleClickRegr={this.showPrograma}/>}
            {verPrograma && <VerPrograma1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showPrograma} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showContacto && <ConfContacto1 styles={this.props.styles} handleClickRegr={this.showConf}
                        handleChange={this.handleChangeBuscEmp} handleSubmit={this.handleBuscEmp}
                        args={argsBuscar}/>}
           
            {addContacto && <AddContacto1 styles={this.props.styles} handleClickRegr={this.showContacto}/>}
            {verContacto && <VerContacto1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showContacto} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {/* {showOperario && <ConfOperario1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addOperario && <AddOperario1 styles={this.props.styles} handleClickRegr={this.showOperario}/>}
            {verOperario && <VerOperario1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showOperario} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>} */}

            {showFabricante && <ConfFabricante1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addFabricante && <AddFabricante1 styles={this.props.styles} handleClickRegr={this.showFabricante}/>}
            {verFabricante && <VerFabricante1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showFabricante} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showUnidad && <ConfUnidad1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addUnidad && <AddUnidad1 styles={this.props.styles} handleClickRegr={this.showUnidad}/>}
            {verUnidad && <VerUnidad1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showUnidad} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showProveed && <ConfProveed1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addProveed && <AddProveed1 styles={this.props.styles} handleClickRegr={this.showProveed}/>}
            {verProveed && <VerProveed1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showProveed} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showProducto && <ConfProducto1 styles={this.props.styles} handleClickSel2={this.showUpdPro} 
                handleSubmit={this.handleBuscPro} handleChange={this.handleChangeBuscPro} args={argsBuscar}
                handleClickSel1={this.showDescProducto} autorizacUA={this.props.autorizacUA} handleClickRegr={this.showConf}/>}
            {addProducto && <AddProducto1 styles={this.props.styles} handleClickRegr={this.showProducto}/>}
            {verProducto && <VerProducto1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showProducto} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showMaterial && <ConfMaterial1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addMaterial && <AddMaterial1 styles={this.props.styles} handleClickRegr={this.showMaterial}/>}
            {verMaterial && <VerMaterial1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showMaterial} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showEncuesta && <ConfEncuesta1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addEncuesta && <AddEncuesta1 styles={this.props.styles} handleClickRegr={this.showEncuesta}/>}
            {verEncuesta && <VerEncuesta1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showEncuesta} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showPolitica && <AdminPolitica1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addPolitica && <AddPolitica1 styles={this.props.styles} handleClickRegr={this.showPolitica}/>}
            {verPolitica && <VerPolitica1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showPolitica} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}
            {showUpdPro && <CargPro1 styles={this.props.styles} handleClickRegr={this.showProducto}/>}

            {showParametro && <VerParam1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleClickRegr={this.showConf} handleClickUpd={this.handleClickUpd}/>}
          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showConf && <HomeConf2 styles={this.props.styles}/>}

            {showEmpresa && <ConfEmpresa2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                argsBuscEmp={argsBuscEmp}
                handleClick={this.addEmpresa} list={lista} handleClickidLista={this.idLista}/>} 
            {addEmpresa && <AddEmpresa2 styles={this.props.styles} handleSubmit={this.handleEmpresa} 
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} 
                handleLista={this.handleSelcomercialAtiende} handleLista1={this.handleSelPais}/>}
            {verEmpresa && <VerEmpresa2 styles={this.props.styles} handleSubmit={this.handleEmpresa} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} list={lista}
                permiteDelete={permiteDelete}/>}

            {showHallazgo && <ConfHallazgo2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addHallazgo} list={lista} handleClickidLista={this.idLista}/>}
            {addHallazgo && <AddHallazgo2 styles={this.props.styles} 
                handleSubmit={this.handleHallazgo} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verHallazgo && <VerHallazgo2 styles={this.props.styles} handleSubmit={this.handleHallazgo} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showUtilidad && <ConfUtilidad2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addUtilidad} list={lista} handleClickidLista={this.idLista}/>}
            {addUtilidad && <AddUtilidad2 styles={this.props.styles} 
                handleSubmit={this.handleUtilidad} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verUtilidad && <VerUtilidad2 styles={this.props.styles} handleSubmit={this.handleUtilidad} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showPrograma && <ConfPrograma2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addPrograma} list={lista} handleClickidLista={this.idLista}/>}
            {addPrograma && <AddPrograma2 styles={this.props.styles} 
                handleSubmit={this.handlePrograma} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verPrograma && <VerPrograma2 styles={this.props.styles} handleSubmit={this.handlePrograma} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showContacto && <ConfContacto2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addContacto} list={lista} handleClickidLista={this.idLista} argsBuscEmp={argsBuscEmp}/>}
            {addContacto && <AddContacto2 styles={this.props.styles} list={lista} 
               handleLista={this.handleSelDescrEmpresa}
                handleSubmit={this.handleContacto} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verContacto && <VerContacto2 styles={this.props.styles} list={lista} handleSubmit={this.handleContacto} metaTipo="Comercial"
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {/* {showOperario && <ConfOperario2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addOperario} list={lista} handleClickidLista={this.idLista}/>}
            {addOperario && <AddOperario2 styles={this.props.styles} handleSubmit={this.handleOperario} 
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verOperario && <VerOperario2 styles={this.props.styles} handleSubmit={this.handleOperario} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>} */}

            {showFabricante && <ConfFabricante2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addFabricante} list={lista} handleClickidLista={this.idLista}/>}
            {addFabricante && <AddFabricante2 styles={this.props.styles} handleSubmit={this.handleFabricante} 
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verFabricante && <VerFabricante2 styles={this.props.styles} handleSubmit={this.handleFabricante} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showUnidad && <ConfUnidad2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addUnidad} list={lista} handleClickidLista={this.idLista}/>}
            {addUnidad && <AddUnidad2 styles={this.props.styles} handleLista={this.handleSelTipoUnidad} 
                handleSubmit={this.handleUnidad} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verUnidad && <VerUnidad2 styles={this.props.styles} handleSubmit={this.handleUnidad} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showProveed && <ConfProveed2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addProveed} list={lista} handleClickidLista={this.idLista}/>}
            {addProveed && <AddProveed2 styles={this.props.styles} handleLista={this.handleSelDescrDocumento} 
                handleSubmit={this.handleProveed} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verProveed && <VerProveed2 styles={this.props.styles} handleSubmit={this.handleProveed} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showProducto && <ConfProducto2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addProducto} list={lista} handleClickidLista={this.idLista} argsBuscPro={argsBuscPro}/>}
            {addProducto && <AddProducto2 styles={this.props.styles} handleLista={this.handleSelTipoProducto} handleLista3={this.handleSelTipoOrden} 
                handleLista1={this.handleSelDescrUnidad} handleLista2={this.handleSelDescrLubricante} handleLista55={this.handleSelMoneda}
                handleSubmit={this.handleProducto} listUni={lista11} listLub={lista12} autorizacUA={this.props.autorizacUA}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} fechaHasta={fechaHasta} />}
            {verProducto && <VerProducto2 styles={this.props.styles} handleSubmit={this.handleProducto} 
                args={argsAdd} errors={errorAdd} listUni={lista11} idLista={idLista} listLub={lista12} fechaHasta={fechaHasta}
                 permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} autorizacUA={this.props.autorizacUA}/>}

            {showMaterial && <ConfMaterial2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addMaterial} list={lista} handleClickidLista={this.idLista}/>}
            {addMaterial && <AddMaterial2 styles={this.props.styles} handleLista={this.handleSelTipoMaterial} 
                handleSubmit={this.handleMaterial} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verMaterial && <VerMaterial2 styles={this.props.styles} handleSubmit={this.handleMaterial} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showEncuesta && <ConfEncuesta2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addEncuesta} list={lista} handleClickidLista={this.idLista}/>}
            {addEncuesta && <AddEncuesta2 styles={this.props.styles} 
                handleSubmit={this.handleEncuesta} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verEncuesta && <VerEncuesta2 styles={this.props.styles} handleSubmit={this.handleEncuesta} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showPolitica && <AdminPolitica2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addPolitica} list={lista} handleClickidLista={this.idLista}/>}
            {addPolitica && <AddPolitica2 styles={this.props.styles} handleLista={this.handleSelTipoPolitica} 
                handleSubmit={this.handlePolitica} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verPolitica && <VerPolitica2 styles={this.props.styles} handleSubmit={this.handlePolitica} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showUpdPro && <CargPro2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}/>}

            {showParametro && <VerParam2 styles={this.props.styles} list={lista} handleSubmit={this.handleParametro}
                args={argsAdd} errors={errorAdd} permiteUpdate={permiteUpdate}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'xxxxxx'}}]`}}}}),

  graphql(queries.mutation.createEmpresa, {name:'createEmpresa'}),
  graphql(queries.mutation.editEmpresa, {name:'editEmpresa'}),
  graphql(queries.mutation.deleteEmpresa, {name:'deleteEmpresa'}),

  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),

  graphql(queries.query.allHallazgo, {name:'allHallazgo'}),
  graphql(queries.mutation.createHallazgo, {name:'createHallazgo'}),
  graphql(queries.mutation.editHallazgo, {name:'editHallazgo'}),
  graphql(queries.mutation.deleteHallazgo, {name:'deleteHallazgo'}),

  graphql(queries.query.allUtilidad, {name:'allUtilidad'}),
  graphql(queries.mutation.createUtilidad, {name:'createUtilidad'}),
  graphql(queries.mutation.editUtilidad, {name:'editUtilidad'}),
  graphql(queries.mutation.deleteUtilidad, {name:'deleteUtilidad'}),

  graphql(queries.query.allPrograma, {name:'allPrograma'}),
  graphql(queries.mutation.createPrograma, {name:'createPrograma'}),
  graphql(queries.mutation.editPrograma, {name:'editPrograma'}),
  graphql(queries.mutation.deletePrograma, {name:'deletePrograma'}),

  graphql(queries.query.allContacto, {name:'allContacto'}),
  graphql(queries.mutation.createContacto, {name:'createContacto'}),
  graphql(queries.mutation.editContacto, {name:'editContacto'}),
  graphql(queries.mutation.deleteContacto, {name:'deleteContacto'}),
  
  graphql(queries.query.allFabricante, {name:'allFabricante'}),
  graphql(queries.mutation.createFabricante, {name:'createFabricante'}),
  graphql(queries.mutation.editFabricante, {name:'editFabricante'}),
  graphql(queries.mutation.deleteFabricante, {name:'deleteFabricante'}),

  graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.mutation.createUnidad, {name:'createUnidad'}),
  graphql(queries.mutation.editUnidad, {name:'editUnidad'}),
  graphql(queries.mutation.deleteUnidad, {name:'deleteUnidad'}),

  graphql(queries.query.allLubricante, {name:'allLubricante'}),

  graphql(queries.query.allProveed, {name:'allProveed'}),
  graphql(queries.mutation.createProveed, {name:'createProveed'}),
  graphql(queries.mutation.editProveed, {name:'editProveed'}),
  graphql(queries.mutation.deleteProveed, {name:'deleteProveed'}),

  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  // graphql(queries.mutation.createLubricante, {name:'createLubricante'}),
  // graphql(queries.mutation.editLubricante, {name:'editLubricante'}),
  // graphql(queries.mutation.deleteLubricante, {name:'deleteLubricante'}),
  graphql(queries.query.allProductoRtes, {name:'allProductoRtes',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numProducto: 1}}]`}}}}),
  graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.mutation.createProducto, {name:'createProducto'}),
  graphql(queries.mutation.editProducto, {name:'editProducto'}),
  graphql(queries.mutation.deleteProducto, {name:'deleteProducto'}),  
  
  graphql(queries.query.allMaterial, {name:'allMaterial'}),
  graphql(queries.mutation.createMaterial, {name:'createMaterial'}),
  graphql(queries.mutation.editMaterial, {name:'editMaterial'}),
  graphql(queries.mutation.deleteMaterial, {name:'deleteMaterial'}),

  graphql(queries.query.allEncuesta, {name:'allEncuesta'}),
  graphql(queries.mutation.createEncuesta, {name:'createEncuesta'}),
  graphql(queries.mutation.editEncuesta, {name:'editEncuesta'}),
  graphql(queries.mutation.deleteEncuesta, {name:'deleteEncuesta'}),

  graphql(queries.query.allPolitica, {name:'allPolitica'}),
  graphql(queries.mutation.createPolitica, {name:'createPolitica'}),
  graphql(queries.mutation.editPolitica, {name:'editPolitica'}),
  graphql(queries.mutation.deletePolitica, {name:'deletePolitica'}),

  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createParametro, {name:'createParametro'}),
  graphql(queries.mutation.editParametro, {name:'editParametro'}),

  graphql(queries.query.allSequence, {name:'allSequence', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createSequence, {name:'createSequence'}),
  graphql(queries.mutation.editSequence, {name:'editSequence'}),
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes2',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Comercial'}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeConf)
